import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL, PANEl_BASE_URL } from '@app/contstants/endpoints';
import { format } from 'date-fns';
import { IAccountDynamicsListItem } from '@entities/accountDynamics/IAccountDynamicsListItem';
import { IAccountDynamicsFilter } from '@pages/AccountsDynamics/List/filter';

export interface IAccountDynamicsList {
  items: IAccountDynamicsListItem[];
  total_pages: number;
  total_items: number;
  current_page: number;
}

export const fetch = async (filters: IAccountDynamicsFilter): Promise<IAccountDynamicsList> => {
  let data = {};

  if (filters.search?.length) {
    data = { ...data, q: filters.search };
  }

  if (filters.dateFrom) {
    data = {
      ...data,
      date_from: format(new Date(filters.dateFrom), 'yyyy-MM-dd'),
    };
  }

  if (filters.dateTo) {
    data = {
      ...data,
      date_to: format(new Date(filters.dateTo), 'yyyy-MM-dd'),
    };
  }

  if (filters.sort) {
    data = {
      ...data,
      sort_order: filters.sort.type,
      sort_by: filters.sort.column,
    };
  }

  const response = await api.get<IAccountDynamicsList>(`${BI_BASE_URL}/dynamic/`, {
    params: {
      managers_ids: filters.managers,
      region: filters.regions,
      source: filters.sources,
      tags: filters.tags,
      page: filters.page,
      accounts: filters.accounts,
      account_type: filters.accountType,
      activities: filters.activity,
      account_statuses: filters.created_at,
      page_size: filters.perPage,
      ...data,
    },
  });

  return response.data ?? [];
};

export const useAccountDynamicsList = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
